import React, {useEffect} from 'react';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import {useSelector, useDispatch} from 'react-redux';
import {getBookById} from '../../../redux/slices/booksSlice';
import {AppDispatch, RootState} from '../../../redux/store';
import {Contributors} from './component/Contributors';
import {Awards} from './component/Awards';
import {DateWithFormat} from '../components/DateWithFormat';
import theme, {imageSize} from '../../../styles/theme';

const Book = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {loading = false, current = null} = useSelector(
    (state: RootState) => state.books,
  );

  const params = new URLSearchParams(document.location.search);
  const id = params.get('id');
  useEffect(() => {
    if (id) {
      void dispatch(getBookById({id}));
    }
  }, [id]);

  let contributorCollection = null;
  if (current?.contributors && current?.contributors.length > 0) {
    contributorCollection = current.contributors;
  }

  let awardsCollection = null;
  if (current?.badges.awards && current?.badges.awards.length > 0) {
    awardsCollection = current?.badges.awards;
  }

  if (loading) {
    return (
      <Grid
        height="80vh"
        display="flex"
        justifyContent="center"
        alignItems="center">
        <CircularProgress />
      </Grid>
    );
  }
  if (current !== null) {
    return (
      <Grid marginTop="3vh">
        <Grid
          display="flex"
          justifyContent="center"
          alignItems="center"
          container>
          <Grid
            display="flex"
            justifyContent="center"
            margin={theme.margin.sm}
            item>
            <img src={current?.image_url} height={imageSize.bookPage} alt="" />
          </Grid>
          <Grid item xs={10} sm={4}>
            <h3>{current?.title}</h3>
            <p>{current?.author_name}</p>
            <p>
              <DateWithFormat date={current?.publication_date} />
            </p>
            <p>
              <b>ISBN-13: </b> {current?.ean}
            </p>
            <p>${current?.price}</p>
            <p>{current?.product_form}</p>
          </Grid>
        </Grid>
        <Grid
          display="flex"
          justifyContent="center"
          alignItems="center"
          container>
          <Grid item xs={10} sm={6}>
            <p>
              <b>language: </b>
              {current?.language}
            </p>
            <p>
              <b>Page count: </b>
              {current?.page_count}
            </p>
            <p>
              <b>Publisher name: </b>
              {current?.publisher_name}
            </p>
            <Contributors collection={contributorCollection} />
            <Awards collection={awardsCollection} />
          </Grid>
        </Grid>
      </Grid>
    );
  }
  return <p> </p>;
};

export default Book;
